import type { ArcadeMachinesShow } from '@/types';
import { MachineGameView } from './components/machine-game-view';

export default function Show({
  slug,
  title,
  challengeId,
  gameId,
}: ArcadeMachinesShow) {
  return (
    <MachineGameView
      slug={slug}
      title={title}
      challengeId={challengeId}
      gameId={gameId}
    />
  );
}
